export default {
	en: {
		nav: {
			events: 'Events',
			myEvents: 'My Events',
			createAccount: 'Create Account',
			judges: 'Judges',
			myAccount: 'My Account',
			logIn: 'Log In',
			logOut: 'Log Out',
			ranks: {
				all: 'All'
			}
		},
		logIn: {
			header: 'Log In',
			mail: 'E-mail',
			password: 'Password',
			signIn: 'Log in',
			or: 'or',
			create: 'Create an Account',
			forgotten: 'Forgotten your password?'
		},
		activation: {
			headline: 'Check your inbox!',
			subheadline: 'We send you activation link',
			confirmation: 'Your account is active now',
			sub: 'You can sign in!'
		},
		reset: {
			header: 'Reset password',
			button: 'Reset Password',
			cancel: 'Cancel',
			page: {
				headline: 'Check your inbox!',
				subheadline: 'We send you a password reset link',
				passwordChanged: 'Password has been changed',
				use: 'Use new Password to sign in!',
				set: 'Set new password!',
				newPass: 'New password',
				newPassConfirmation: 'New password confirmation',
				button: 'Set new Password'
			}
		},
		home: {
			header: {
				headline_discover: 'Discover',
				headline_rest: 'FCI dog shows across Europe',
				inputs: {
					breed: 'Breed',
					country: 'Country'
				},
				button: 'Discover Shows'
			},
			features: {
				user: {
					headline: 'User Friendly',
					description: 'Easily find all FCI dog shows across Europe in a simple and intuitive way'
				},
				plan: {
					headline: 'Plan & Sync',
					description: 'Plan your personal list of dog shows and synchronize it with your calendar'
				},
				opinions: {
					headline: 'Share Opinions',
					description: 'Check out and share your opinions about the dog show judges'
				}
			},
			slider: {
				headline: 'Events',
				subheadline: 'Most popular',
				button: 'See All Events'
			},
			sign: {
				headline: 'Sign up!',
				subheadline: 'Create an account to explore the best dog shows',
				button: 'Create an account'
			},
			contact: {
				headline: 'Contact',
				events: {
					headline: 'Discover Events',
					all: 'All Events'
				},
				socials: 'Follow us'
			},
			partners: 'Our Partners'
		},
		events: {
			rank: {
				international: 'international',
				national: 'national',
				club: 'club'
			},
			calendar: {
				from: 'From',
				to: 'To'
			},
			header: 'Events',
			myEvents: 'My Events',
			stripes: {
				judges: 'See all judges',
				all: 'See all'
			},
			buttons: {
				remind: 'Remind',
				unremind: 'Unremind',
				remindInfo: 'Remind me about each event’s application deadline 3 and 1 days beforehand, via e-mail.',
				sync: 'Synchronize',
				syncInfo: 'Synchronize events with my computer’s and/or phone’s calendar.'
			}
		},
		event: {
			rank: 'Rank',
			deadline: 'Application Deadline',
			fav: 'Add to My Events',
			remove: 'Remove from My Events',
			apply: 'Apply to show',
			hotel: 'Find your hotel with',
			location: 'Location',
			maps: 'See on',
			judges: 'Event Judges',
			breed: 'Breed',
			removeBreed: 'Remove breed',
			group: 'Group'
		},
		judges: {
			header: 'Judges',
			ratings: 'no ratings',
			reviews: 'Reviews',
			removeComment: 'Remove comment'
		},
		judge: {
			reviews: 'reviews',
			allComments: 'see all comments below',
			comment: 'Your Comment',
			name: 'Full Name',
			breed: 'Dog breed',
			remove: 'remove breed',
			anonymous: 'stay anonymous',
			opinion: 'Your opinion',
			rate: 'Rate the judge',
			button: 'Add Comment'
		},
		account: {
			header: 'Create Account',
			my: 'My Account',
			basics: {
				header: 'Name and Email',
				name: 'First Name',
				lastName: 'Last Name',
				email: 'Email'
			},
			adress: {
				header: 'Adress',
				street: 'Street',
				city: 'City',
				post: 'Post Code',
				country: 'Country',
				remove: 'Remove country',
				description: 'Please enter your address if you wish to search events also by distance from your place of residence.'
			},
			breeds: {
				header: 'My Breeds',
				breed: 'Breed',
				remove: 'Remove breed',
				description: 'Please enter your breeds if you wish to get more accurate search results of events suitable for you.',
				obligatory: 'Obligatory fields - at least one breed'
			},
			password: {
				header: 'Password',
				pass: 'Password',
				confirmPass: 'Password confirmation',
				newPass: 'New Password',
				newPassConfirmation: 'New Password Confirmation'
			},
			terms: {
				header: 'Terms and conditions apply:',
				agreements: {
					header: 'By clicking Create an Account you agree to our Terms and conditions and our Cookie policy.',
					first: 'First obligatory agreement',
					second: 'Second obligatory agreement',
					third: 'Third obligatory agreement'
				}
			},
			button: 'Create an Account',
			update: 'Update Account',
			obligatory: 'Obligatory fields'
		},
		noResults: 'No Results',
		pdf: 'Download as',
		back: 'Back',
		filters: {
			remove: 'Remove filter',
			narrow: 'Narrow By',
			search: 'Search by name',
			sort: 'Sort By',
			comments: 'Show comments narrow by',
			dog: 'Dog Breeds',
			group: 'Breed Group',
			rank: 'Event Rank',
			country: 'Country',
			distance: 'Distance',
			date: 'Date',
			breeds: 'Breeds',
			judge: 'Judge name',
			all: 'All',
			future: 'Future',
			past: 'Past',
			letter: 'Alphabetic letter',
			name: 'Name',
			buttonResultsName: 'Filters',
			buttonNoResultsName: 'Nie wybrałeś żadnego filtra',
			stars: {
				name: 'Stars count',
				most: 'Most Stars',
				least: 'Least Stars'
			},
			reviews: {
				name: 'Reviews count',
				most: 'Most Reviews',
				least: 'Least Reviews'
			}
		},
		errors: {
			confirmedPassword: 'Password doesnt match',
			agreements: 'Check all obligatory agreements'
		}
	},
	pl: {
		nav: {
			events: 'Events',
			myEvents: 'My Events',
			createAccount: 'Create Account',
			judges: 'Judges',
			myAccount: 'My Account',
			logIn: 'Log In',
			logOut: 'Log Out',
			ranks: {
				all: 'All'
			}
		},
		logIn: {
			header: 'Log In',
			mail: 'E-mail',
			password: 'Password',
			signIn: 'Log in',
			or: 'or',
			create: 'Create an Account',
			forgotten: 'Forgotten your password?'
		},
		activation: {
			headline: 'Check your inbox!',
			subheadline: 'We send you activation link',
			confirmation: 'Your account is active now',
			sub: 'You can sign in!'
		},
		reset: {
			header: 'Reset password',
			button: 'Reset Password',
			cancel: 'Cancel',
			page: {
				headline: 'Check your inbox!',
				subheadline: 'We send you a password reset link',
				passwordChanged: 'Password has been changed',
				use: 'Use new Password to sign in!',
				set: 'Set new password!',
				newPass: 'New password',
				newPassConfirmation: 'New password confirmation',
				button: 'Set new Password'
			}
		},
		home: {
			header: {
				headline_discover: 'Discover',
				headline_rest: 'FCI dog shows across Europe',
				inputs: {
					breed: 'Breed',
					country: 'Country'
				},
				button: 'Discover Shows'
			},
			features: {
				user: {
					headline: 'User Friendly',
					description: 'Easily find all FCI dog shows across Europe in a simple and intuitive way'
				},
				plan: {
					headline: 'Plan & Sync',
					description: 'Plan your personal list of dog shows and synchronize it with your calendar'
				},
				opinions: {
					headline: 'Share Opinions',
					description: 'Check out and share your opinions about the dog show judges'
				}
			},
			slider: {
				headline: 'Events',
				subheadline: 'Most popular',
				button: 'See All Events'
			},
			sign: {
				headline: 'Sign up!',
				subheadline: 'Create an account to explore the best dog shows',
				button: 'Create an account'
			},
			contact: {
				headline: 'Contact',
				events: {
					headline: 'Discover Events',
					all: 'All Events'
				},
				socials: 'Follow us'
			},
			partners: 'Our Partners'
		},
		events: {
			rank: {
				international: 'international',
				national: 'national',
				club: 'club'
			},
			calendar: {
				from: 'From',
				to: 'To'
			},
			header: 'Events',
			myEvents: 'My Events',
			stripes: {
				judges: 'See all judges',
				all: 'See all'
			},
			buttons: {
				remind: 'Remind',
				unremind: 'Unremind',
				remindInfo: 'Remind me about each event’s application deadline 3 and 1 days beforehand, via e-mail.',
				sync: 'Synchronize',
				syncInfo: 'Synchronize events with my computer’s and/or phone’s calendar.'
			}
		},
		event: {
			rank: 'Rank',
			deadline: 'Application Deadline',
			fav: 'Add to My Events',
			remove: 'Remove from My Events',
			apply: 'Apply to show',
			hotel: 'Find your hotel with',
			location: 'Location',
			maps: 'See on',
			judges: 'Event Judges',
			breed: 'Breed',
			removeBreed: 'Remove breed',
			group: 'Group'
		},
		judges: {
			header: 'Judges',
			ratings: 'no ratings',
			reviews: 'Reviews',
			removeComment: 'Remove comment'
		},
		judge: {
			reviews: 'reviews',
			allComments: 'see all comments below',
			comment: 'Your Comment',
			name: 'Full Name',
			breed: 'Dog breed',
			remove: 'remove breed',
			anonymous: 'stay anonymous',
			opinion: 'Your opinion',
			rate: 'Rate the judge',
			button: 'Add Comment'
		},
		account: {
			header: 'Create Account',
			my: 'My Account',
			basics: {
				header: 'Name and Email',
				name: 'First Name',
				lastName: 'Last Name',
				email: 'Email'
			},
			adress: {
				header: 'Adress',
				street: 'Street',
				city: 'City',
				post: 'Post Code',
				country: 'Country',
				remove: 'Remove country',
				description: 'Please enter your address if you wish to search events also by distance from your place of residence.'
			},
			breeds: {
				header: 'My Breeds',
				breed: 'Breed',
				remove: 'Remove breed',
				description: 'Please enter your breeds if you wish to get more accurate search results of events suitable for you.',
				obligatory: 'Obligatory fields - at least one breed'
			},
			password: {
				header: 'Password',
				pass: 'Password',
				confirmPass: 'Password confirmation',
				newPass: 'New Password',
				newPassConfirmation: 'New Password Confirmation'
			},
			terms: {
				header: 'Terms and conditions apply:',
				agreements: {
					header: 'By clicking Create an Account you agree to our Terms and conditions and our Cookie policy.',
					first: 'First obligatory agreement',
					second: 'Second obligatory agreement',
					third: 'Third obligatory agreement'
				}
			},
			button: 'Create an Account',
			update: 'Update Account',
			obligatory: 'Obligatory fields'
		},
		noResults: 'No Results',
		pdf: 'Download as',
		back: 'Back',
		filters: {
			remove: 'Remove filter',
			narrow: 'Narrow By',
			search: 'Search By name',
			sort: 'Sort By',
			comments: 'Show comments narrow by',
			dog: 'Dog Breeds',
			group: 'Breed Group',
			rank: 'Event Rank',
			country: 'Country',
			distance: 'Distance',
			distanceFrom: 'from',
			date: 'Date',
			breeds: 'Breeds',
			judge: 'Judge name',
			all: 'All',
			future: 'Future',
			past: 'Past',
			letter: 'Alphabetic letter',
			name: 'Name',
			buttonResultsName: 'Filters',
			buttonNoResultsName: 'Nie wybrałeś żadnego filtra',
			stars: {
				name: 'Stars count',
				most: 'Most Stars',
				least: 'Least Stars'
			},
			reviews: {
				name: 'Reviews count',
				most: 'Most Reviews',
				least: 'Least Reviews'
			}
		},
		errors: {
			confirmedPassword: 'Password doesnt match',
			agreements: 'Check all obligatory agreements'
		}
	},
	de: {
		nav: {
			events: 'Events',
			myEvents: 'My Events',
			createAccount: 'Create Account',
			judges: 'Judges',
			myAccount: 'My Account',
			logIn: 'Log In',
			logOut: 'Log Out',
			ranks: {
				all: 'All'
			}
		},
		logIn: {
			header: 'Log In',
			mail: 'E-mail',
			password: 'Password',
			signIn: 'Log in',
			or: 'or',
			create: 'Create an Account',
			forgotten: 'Forgotten your password?'
		},
		activation: {
			headline: 'Check your inbox!',
			subheadline: 'We send you activation link',
			confirmation: 'Your account is active now',
			sub: 'You can sign in!'
		},
		reset: {
			header: 'Reset password',
			button: 'Reset Password',
			cancel: 'Cancel',
			page: {
				headline: 'Check your inbox!',
				subheadline: 'We send you a password reset link',
				passwordChanged: 'Password has been changed',
				use: 'Use new Password to sign in!',
				set: 'Set new password!',
				newPass: 'New password',
				newPassConfirmation: 'New password confirmation',
				button: 'Set new Password'
			}
		},
		home: {
			header: {
				headline_discover: 'Discover',
				headline_rest: 'FCI dog shows across Europe',
				inputs: {
					breed: 'Breed',
					country: 'Country'
				},
				button: 'Discover Shows'
			},
			features: {
				user: {
					headline: 'User Friendly',
					description: 'Easily find all FCI dog shows across Europe in a simple and intuitive way'
				},
				plan: {
					headline: 'Plan & Sync',
					description: 'Plan your personal list of dog shows and synchronize it with your calendar'
				},
				opinions: {
					headline: 'Share Opinions',
					description: 'Check out and share your opinions about the dog show judges'
				}
			},
			slider: {
				headline: 'Events',
				subheadline: 'Most popular',
				button: 'See All Events'
			},
			sign: {
				headline: 'Sign up!',
				subheadline: 'Create an account to explore the best dog shows',
				button: 'Create an account'
			},
			contact: {
				headline: 'Contact',
				events: {
					headline: 'Discover Events',
					all: 'All Events'
				},
				socials: 'Follow us'
			},
			partners: 'Our Partners'
		},
		events: {
			rank: {
				international: 'international',
				national: 'national',
				club: 'club'
			},
			calendar: {
				from: 'From',
				to: 'To'
			},
			header: 'Events',
			myEvents: 'My Events',
			stripes: {
				judges: 'See all judges',
				all: 'See all'
			},
			buttons: {
				remind: 'Remind',
				unremind: 'Unremind',
				remindInfo: 'Remind me about each event’s application deadline 3 and 1 days beforehand, via e-mail.',
				sync: 'Synchronize',
				syncInfo: 'Synchronize events with my computer’s and/or phone’s calendar.'
			}
		},
		event: {
			rank: 'Rank',
			deadline: 'Application Deadline',
			fav: 'Add to My Events',
			remove: 'Remove from My Events',
			apply: 'Apply to show',
			hotel: 'Find your hotel with',
			location: 'Location',
			maps: 'See on',
			judges: 'Event Judges',
			breed: 'Breed',
			removeBreed: 'Remove breed',
			group: 'Group'
		},
		judges: {
			header: 'Judges',
			ratings: 'no ratings',
			reviews: 'Reviews',
			removeComment: 'Remove comment'
		},
		judge: {
			reviews: 'reviews',
			allComments: 'see all comments below',
			comment: 'Your Comment',
			name: 'Full Name',
			breed: 'Dog breed',
			remove: 'remove breed',
			anonymous: 'stay anonymous',
			opinion: 'Your opinion',
			rate: 'Rate the judge',
			button: 'Add Comment'
		},
		account: {
			header: 'Create Account',
			my: 'My Account',
			basics: {
				header: 'Name and Email',
				name: 'First Name',
				lastName: 'Last Name',
				email: 'Email'
			},
			adress: {
				header: 'Adress',
				street: 'Street',
				city: 'City',
				post: 'Post Code',
				country: 'Country',
				remove: 'Remove country',
				description: 'Please enter your address if you wish to search events also by distance from your place of residence.'
			},
			breeds: {
				header: 'My Breeds',
				breed: 'Breed',
				remove: 'Remove breed',
				description: 'Please enter your breeds if you wish to get more accurate search results of events suitable for you.',
				obligatory: 'Obligatory fields - at least one breed'
			},
			password: {
				header: 'Password',
				pass: 'Password',
				confirmPass: 'Password confirmation',
				newPass: 'New Password',
				newPassConfirmation: 'New Password Confirmation'
			},
			terms: {
				header: 'Terms and conditions apply:',
				agreements: {
					header: 'By clicking Create an Account you agree to our Terms and conditions and our Cookie policy.',
					first: 'First obligatory agreement',
					second: 'Second obligatory agreement',
					third: 'Third obligatory agreement'
				}
			},
			button: 'Create an Account',
			update: 'Update Account',
			obligatory: 'Obligatory fields'
		},
		noResults: 'No Results',
		pdf: 'Download as',
		back: 'Back',
		filters: {
			remove: 'Remove filter',
			narrow: 'Narrow By',
			search: 'Search By name',
			sort: 'Sort By',
			comments: 'Show comments narrow by',
			dog: 'Dog Breeds',
			group: 'Breed Group',
			rank: 'Event Rank',
			country: 'Country',
			distance: 'Distance',
			distanceFrom: 'from',
			date: 'Date',
			breeds: 'Breeds',
			judge: 'Judge name',
			all: 'All',
			future: 'Future',
			past: 'Past',
			letter: 'Alphabetic letter',
			name: 'Name',
			buttonResultsName: 'Filters',
			buttonNoResultsName: 'Nie wybrałeś żadnego filtra',
			stars: {
				name: 'Stars count',
				most: 'Most Stars',
				least: 'Least Stars'
			},
			reviews: {
				name: 'Reviews count',
				most: 'Most Reviews',
				least: 'Least Reviews'
			}
		},
		errors: {
			confirmedPassword: 'Password doesnt match',
			agreements: 'Check all obligatory agreements'
		}
	},
	ru: {
		nav: {
			events: 'Events',
			myEvents: 'My Events',
			createAccount: 'Create Account',
			judges: 'Judges',
			myAccount: 'My Account',
			logIn: 'Log In',
			logOut: 'Log Out',
			ranks: {
				all: 'All'
			}
		},
		logIn: {
			header: 'Log In',
			mail: 'E-mail',
			password: 'Password',
			signIn: 'Log in',
			or: 'or',
			create: 'Create an Account',
			forgotten: 'Forgotten your password?'
		},
		activation: {
			headline: 'Check your inbox!',
			subheadline: 'We send you activation link',
			confirmation: 'Your account is active now',
			sub: 'You can sign in!'
		},
		reset: {
			header: 'Reset password',
			button: 'Reset Password',
			cancel: 'Cancel',
			page: {
				headline: 'Check your inbox!',
				subheadline: 'We send you a password reset link',
				passwordChanged: 'Password has been changed',
				use: 'Use new Password to sign in!',
				set: 'Set new password!',
				newPass: 'New password',
				newPassConfirmation: 'New password confirmation',
				button: 'Set new Password'
			}
		},
		home: {
			header: {
				headline_discover: 'Discover',
				headline_rest: 'FCI dog shows across Europe',
				inputs: {
					breed: 'Breed',
					country: 'Country'
				},
				button: 'Discover Shows'
			},
			features: {
				user: {
					headline: 'User Friendly',
					description: 'Easily find all FCI dog shows across Europe in a simple and intuitive way'
				},
				plan: {
					headline: 'Plan & Sync',
					description: 'Plan your personal list of dog shows and synchronize it with your calendar'
				},
				opinions: {
					headline: 'Share Opinions',
					description: 'Check out and share your opinions about the dog show judges'
				}
			},
			slider: {
				headline: 'Events',
				subheadline: 'Most popular',
				button: 'See All Events'
			},
			sign: {
				headline: 'Sign up!',
				subheadline: 'Create an account to explore the best dog shows',
				button: 'Create an account'
			},
			contact: {
				headline: 'Contact',
				events: {
					headline: 'Discover Events',
					all: 'All Events'
				},
				socials: 'Follow us'
			},
			partners: 'Our Partners'
		},
		events: {
			rank: {
				international: 'international',
				national: 'national',
				club: 'club'
			},
			calendar: {
				from: 'From',
				to: 'To'
			},
			header: 'Events',
			myEvents: 'My Events',
			stripes: {
				judges: 'See all judges',
				all: 'See all'
			},
			buttons: {
				remind: 'Remind',
				unremind: 'Unremind',
				remindInfo: 'Remind me about each event’s application deadline 3 and 1 days beforehand, via e-mail.',
				sync: 'Synchronize',
				syncInfo: 'Synchronize events with my computer’s and/or phone’s calendar.'
			}
		},
		event: {
			rank: 'Rank',
			deadline: 'Application Deadline',
			fav: 'Add to My Events',
			remove: 'Remove from My Events',
			apply: 'Apply to show',
			hotel: 'Find your hotel with',
			location: 'Location',
			maps: 'See on',
			judges: 'Event Judges',
			breed: 'Breed',
			removeBreed: 'Remove breed',
			group: 'Group'
		},
		judges: {
			header: 'Judges',
			ratings: 'no ratings',
			reviews: 'Reviews',
			removeComment: 'Remove comment'
		},
		judge: {
			reviews: 'reviews',
			allComments: 'see all comments below',
			comment: 'Your Comment',
			name: 'Full Name',
			breed: 'Dog breed',
			remove: 'remove breed',
			anonymous: 'stay anonymous',
			opinion: 'Your opinion',
			rate: 'Rate the judge',
			button: 'Add Comment'
		},
		account: {
			header: 'Create Account',
			my: 'My Account',
			basics: {
				header: 'Name and Email',
				name: 'First Name',
				lastName: 'Last Name',
				email: 'Email'
			},
			adress: {
				header: 'Adress',
				street: 'Street',
				city: 'City',
				post: 'Post Code',
				country: 'Country',
				remove: 'Remove country',
				description: 'Please enter your address if you wish to search events also by distance from your place of residence.'
			},
			breeds: {
				header: 'My Breeds',
				breed: 'Breed',
				remove: 'Remove breed',
				description: 'Please enter your breeds if you wish to get more accurate search results of events suitable for you.',
				obligatory: 'Obligatory fields - at least one breed'
			},
			password: {
				header: 'Password',
				pass: 'Password',
				confirmPass: 'Password confirmation',
				newPass: 'New Password',
				newPassConfirmation: 'New Password Confirmation'
			},
			terms: {
				header: 'Terms and conditions apply:',
				agreements: {
					header: 'By clicking Create an Account you agree to our Terms and conditions and our Cookie policy.',
					first: 'First obligatory agreement',
					second: 'Second obligatory agreement',
					third: 'Third obligatory agreement'
				}
			},
			button: 'Create an Account',
			update: 'Update Account',
			obligatory: 'Obligatory fields'
		},
		noResults: 'No Results',
		pdf: 'Download as',
		back: 'Back',
		filters: {
			remove: 'Remove filter',
			narrow: 'Narrow By',
			search: 'Search By name',
			sort: 'Sort By',
			comments: 'Show comments narrow by',
			dog: 'Dog Breeds',
			group: 'Breed Group',
			rank: 'Event Rank',
			country: 'Country',
			distance: 'Distance',
			distanceFrom: 'from',
			date: 'Date',
			breeds: 'Breeds',
			judge: 'Judge name',
			all: 'All',
			future: 'Future',
			past: 'Past',
			letter: 'Alphabetic letter',
			name: 'Name',
			buttonResultsName: 'Filters',
			buttonNoResultsName: 'Nie wybrałeś żadnego filtra',
			stars: {
				name: 'Stars count',
				most: 'Most Stars',
				least: 'Least Stars'
			},
			reviews: {
				name: 'Reviews count',
				most: 'Most Reviews',
				least: 'Least Reviews'
			}
		},
		errors: {
			confirmedPassword: 'Password doesnt match',
			agreements: 'Check all obligatory agreements'
		}
	},
	sp: {
		nav: {
			events: 'Events',
			myEvents: 'My Events',
			createAccount: 'Create Account',
			judges: 'Judges',
			myAccount: 'My Account',
			logIn: 'Log In',
			logOut: 'Log Out',
			ranks: {
				all: 'All'
			}
		},
		logIn: {
			header: 'Log In',
			mail: 'E-mail',
			password: 'Password',
			signIn: 'Log in',
			or: 'or',
			create: 'Create an Account',
			forgotten: 'Forgotten your password?'
		},
		activation: {
			headline: 'Check your inbox!',
			subheadline: 'We send you activation link',
			confirmation: 'Your account is active now',
			sub: 'You can sign in!'
		},
		reset: {
			header: 'Reset password',
			button: 'Reset Password',
			cancel: 'Cancel',
			page: {
				headline: 'Check your inbox!',
				subheadline: 'We send you a password reset link',
				passwordChanged: 'Password has been changed',
				use: 'Use new Password to sign in!',
				set: 'Set new password!',
				newPass: 'New password',
				newPassConfirmation: 'New password confirmation',
				button: 'Set new Password'
			}
		},
		home: {
			header: {
				headline_discover: 'Discover',
				headline_rest: 'FCI dog shows across Europe',
				inputs: {
					breed: 'Breed',
					country: 'Country'
				},
				button: 'Discover Shows'
			},
			features: {
				user: {
					headline: 'User Friendly',
					description: 'Easily find all FCI dog shows across Europe in a simple and intuitive way'
				},
				plan: {
					headline: 'Plan & Sync',
					description: 'Plan your personal list of dog shows and synchronize it with your calendar'
				},
				opinions: {
					headline: 'Share Opinions',
					description: 'Check out and share your opinions about the dog show judges'
				}
			},
			slider: {
				headline: 'Events',
				subheadline: 'Most popular',
				button: 'See All Events'
			},
			sign: {
				headline: 'Sign up!',
				subheadline: 'Create an account to explore the best dog shows',
				button: 'Create an account'
			},
			contact: {
				headline: 'Contact',
				events: {
					headline: 'Discover Events',
					all: 'All Events'
				},
				socials: 'Follow us'
			},
			partners: 'Our Partners'
		},
		events: {
			rank: {
				international: 'international',
				national: 'national',
				club: 'club'
			},
			calendar: {
				from: 'From',
				to: 'To'
			},
			header: 'Events',
			myEvents: 'My Events',
			stripes: {
				judges: 'See all judges',
				all: 'See all'
			},
			buttons: {
				remind: 'Remind',
				unremind: 'Unremind',
				remindInfo: 'Remind me about each event’s application deadline 3 and 1 days beforehand, via e-mail.',
				sync: 'Synchronize',
				syncInfo: 'Synchronize events with my computer’s and/or phone’s calendar.'
			}
		},
		event: {
			rank: 'Rank',
			deadline: 'Application Deadline',
			fav: 'Add to My Events',
			remove: 'Remove from My Events',
			apply: 'Apply to show',
			hotel: 'Find your hotel with',
			location: 'Location',
			maps: 'See on',
			judges: 'Event Judges',
			breed: 'Breed',
			removeBreed: 'Remove breed',
			group: 'Group'
		},
		judges: {
			header: 'Judges',
			ratings: 'no ratings',
			reviews: 'Reviews',
			removeComment: 'Remove comment'
		},
		judge: {
			reviews: 'reviews',
			allComments: 'see all comments below',
			comment: 'Your Comment',
			name: 'Full Name',
			breed: 'Dog breed',
			remove: 'remove breed',
			anonymous: 'stay anonymous',
			opinion: 'Your opinion',
			rate: 'Rate the judge',
			button: 'Add Comment'
		},
		account: {
			header: 'Create Account',
			my: 'My Account',
			basics: {
				header: 'Name and Email',
				name: 'First Name',
				lastName: 'Last Name',
				email: 'Email'
			},
			adress: {
				header: 'Adress',
				street: 'Street',
				city: 'City',
				post: 'Post Code',
				country: 'Country',
				remove: 'Remove country',
				description: 'Please enter your address if you wish to search events also by distance from your place of residence.'
			},
			breeds: {
				header: 'My Breeds',
				breed: 'Breed',
				remove: 'Remove breed',
				description: 'Please enter your breeds if you wish to get more accurate search results of events suitable for you.',
				obligatory: 'Obligatory fields - at least one breed'
			},
			password: {
				header: 'Password',
				pass: 'Password',
				confirmPass: 'Password confirmation',
				newPass: 'New Password',
				newPassConfirmation: 'New Password Confirmation'
			},
			terms: {
				header: 'Terms and conditions apply:',
				agreements: {
					header: 'By clicking Create an Account you agree to our Terms and conditions and our Cookie policy.',
					first: 'First obligatory agreement',
					second: 'Second obligatory agreement',
					third: 'Third obligatory agreement'
				}
			},
			button: 'Create an Account',
			update: 'Update Account',
			obligatory: 'Obligatory fields'
		},
		noResults: 'No Results',
		pdf: 'Download as',
		back: 'Back',
		filters: {
			remove: 'Remove filter',
			narrow: 'Narrow By',
			search: 'Search By name',
			sort: 'Sort By',
			comments: 'Show comments narrow by',
			dog: 'Dog Breeds',
			group: 'Breed Group',
			rank: 'Event Rank',
			country: 'Country',
			distance: 'Distance',
			distanceFrom: 'from',
			date: 'Date',
			breeds: 'Breeds',
			judge: 'Judge name',
			all: 'All',
			future: 'Future',
			past: 'Past',
			letter: 'Alphabetic letter',
			name: 'Name',
			buttonResultsName: 'Filters',
			buttonNoResultsName: 'Nie wybrałeś żadnego filtra',
			stars: {
				name: 'Stars count',
				most: 'Most Stars',
				least: 'Least Stars'
			},
			reviews: {
				name: 'Reviews count',
				most: 'Most Reviews',
				least: 'Least Reviews'
			}
		},
		errors: {
			confirmedPassword: 'Password doesnt match',
			agreements: 'Check all obligatory agreements'
		}
	},
	fr: {
		nav: {
			events: 'Events',
			myEvents: 'My Events',
			createAccount: 'Create Account',
			judges: 'Judges',
			myAccount: 'My Account',
			logIn: 'Log In',
			logOut: 'Log Out',
			ranks: {
				all: 'All'
			}
		},
		logIn: {
			header: 'Log In',
			mail: 'E-mail',
			password: 'Password',
			signIn: 'Log in',
			or: 'or',
			create: 'Create an Account',
			forgotten: 'Forgotten your password?'
		},
		activation: {
			headline: 'Check your inbox!',
			subheadline: 'We send you activation link',
			confirmation: 'Your account is active now',
			sub: 'You can sign in!'
		},
		reset: {
			header: 'Reset password',
			button: 'Reset Password',
			cancel: 'Cancel',
			page: {
				headline: 'Check your inbox!',
				subheadline: 'We send you a password reset link',
				passwordChanged: 'Password has been changed',
				use: 'Use new Password to sign in!',
				set: 'Set new password!',
				newPass: 'New password',
				newPassConfirmation: 'New password confirmation',
				button: 'Set new Password'
			}
		},
		home: {
			header: {
				headline_discover: 'Discover',
				headline_rest: 'FCI dog shows across Europe',
				inputs: {
					breed: 'Breed',
					country: 'Country'
				},
				button: 'Discover Shows'
			},
			features: {
				user: {
					headline: 'User Friendly',
					description: 'Easily find all FCI dog shows across Europe in a simple and intuitive way'
				},
				plan: {
					headline: 'Plan & Sync',
					description: 'Plan your personal list of dog shows and synchronize it with your calendar'
				},
				opinions: {
					headline: 'Share Opinions',
					description: 'Check out and share your opinions about the dog show judges'
				}
			},
			slider: {
				headline: 'Events',
				subheadline: 'Most popular',
				button: 'See All Events'
			},
			sign: {
				headline: 'Sign up!',
				subheadline: 'Create an account to explore the best dog shows',
				button: 'Create an account'
			},
			contact: {
				headline: 'Contact',
				events: {
					headline: 'Discover Events',
					all: 'All Events'
				},
				socials: 'Follow us'
			},
			partners: 'Our Partners'
		},
		events: {
			rank: {
				international: 'international',
				national: 'national',
				club: 'club'
			},
			calendar: {
				from: 'From',
				to: 'To'
			},
			header: 'Events',
			myEvents: 'My Events',
			stripes: {
				judges: 'See all judges',
				all: 'See all'
			},
			buttons: {
				remind: 'Remind',
				unremind: 'Unremind',
				remindInfo: 'Remind me about each event’s application deadline 3 and 1 days beforehand, via e-mail.',
				sync: 'Synchronize',
				syncInfo: 'Synchronize events with my computer’s and/or phone’s calendar.'
			}
		},
		event: {
			rank: 'Rank',
			deadline: 'Application Deadline',
			fav: 'Add to My Events',
			remove: 'Remove from My Events',
			apply: 'Apply to show',
			hotel: 'Find your hotel with',
			location: 'Location',
			maps: 'See on',
			judges: 'Event Judges',
			breed: 'Breed',
			removeBreed: 'Remove breed',
			group: 'Group'
		},
		judges: {
			header: 'Judges',
			ratings: 'no ratings',
			reviews: 'Reviews',
			removeComment: 'Remove comment'
		},
		judge: {
			reviews: 'reviews',
			allComments: 'see all comments below',
			comment: 'Your Comment',
			name: 'Full Name',
			breed: 'Dog breed',
			remove: 'remove breed',
			anonymous: 'stay anonymous',
			opinion: 'Your opinion',
			rate: 'Rate the judge',
			button: 'Add Comment'
		},
		account: {
			header: 'Create Account',
			my: 'My Account',
			basics: {
				header: 'Name and Email',
				name: 'First Name',
				lastName: 'Last Name',
				email: 'Email'
			},
			adress: {
				header: 'Adress',
				street: 'Street',
				city: 'City',
				post: 'Post Code',
				country: 'Country',
				remove: 'Remove country',
				description: 'Please enter your address if you wish to search events also by distance from your place of residence.'
			},
			breeds: {
				header: 'My Breeds',
				breed: 'Breed',
				remove: 'Remove breed',
				description: 'Please enter your breeds if you wish to get more accurate search results of events suitable for you.',
				obligatory: 'Obligatory fields - at least one breed'
			},
			password: {
				header: 'Password',
				pass: 'Password',
				confirmPass: 'Password confirmation',
				newPass: 'New Password',
				newPassConfirmation: 'New Password Confirmation'
			},
			terms: {
				header: 'Terms and conditions apply:',
				agreements: {
					header: 'By clicking Create an Account you agree to our Terms and conditions and our Cookie policy.',
					first: 'First obligatory agreement',
					second: 'Second obligatory agreement',
					third: 'Third obligatory agreement'
				}
			},
			button: 'Create an Account',
			update: 'Update Account',
			obligatory: 'Obligatory fields'
		},
		noResults: 'No Results',
		pdf: 'Download as',
		back: 'Back',
		filters: {
			remove: 'Remove filter',
			narrow: 'Narrow By',
			search: 'Search By name',
			sort: 'Sort By',
			comments: 'Show comments narrow by',
			dog: 'Dog Breeds',
			group: 'Breed Group',
			rank: 'Event Rank',
			country: 'Country',
			distance: 'Distance',
			distanceFrom: 'from',
			date: 'Date',
			breeds: 'Breeds',
			judge: 'Judge name',
			all: 'All',
			future: 'Future',
			past: 'Past',
			letter: 'Alphabetic letter',
			name: 'Name',
			buttonResultsName: 'Filters',
			buttonNoResultsName: 'Nie wybrałeś żadnego filtra',
			stars: {
				name: 'Stars count',
				most: 'Most Stars',
				least: 'Least Stars'
			},
			reviews: {
				name: 'Reviews count',
				most: 'Most Reviews',
				least: 'Least Reviews'
			}
		},
		errors: {
			confirmedPassword: 'Password doesnt match',
			agreements: 'Check all obligatory agreements'
		}
	},
	it: {
		nav: {
			events: 'Events',
			myEvents: 'My Events',
			createAccount: 'Create Account',
			judges: 'Judges',
			myAccount: 'My Account',
			logIn: 'Log In',
			logOut: 'Log Out',
			ranks: {
				all: 'All'
			}
		},
		logIn: {
			header: 'Log In',
			mail: 'E-mail',
			password: 'Password',
			signIn: 'Log in',
			or: 'or',
			create: 'Create an Account',
			forgotten: 'Forgotten your password?'
		},
		activation: {
			headline: 'Check your inbox!',
			subheadline: 'We send you activation link',
			confirmation: 'Your account is active now',
			sub: 'You can sign in!'
		},
		reset: {
			header: 'Reset password',
			button: 'Reset Password',
			cancel: 'Cancel',
			page: {
				headline: 'Check your inbox!',
				subheadline: 'We send you a password reset link',
				passwordChanged: 'Password has been changed',
				use: 'Use new Password to sign in!',
				set: 'Set new password!',
				newPass: 'New password',
				newPassConfirmation: 'New password confirmation',
				button: 'Set new Password'
			}
		},
		home: {
			header: {
				headline_discover: 'Discover',
				headline_rest: 'FCI dog shows across Europe',
				inputs: {
					breed: 'Breed',
					country: 'Country'
				},
				button: 'Discover Shows'
			},
			features: {
				user: {
					headline: 'User Friendly',
					description: 'Easily find all FCI dog shows across Europe in a simple and intuitive way'
				},
				plan: {
					headline: 'Plan & Sync',
					description: 'Plan your personal list of dog shows and synchronize it with your calendar'
				},
				opinions: {
					headline: 'Share Opinions',
					description: 'Check out and share your opinions about the dog show judges'
				}
			},
			slider: {
				headline: 'Events',
				subheadline: 'Most popular',
				button: 'See All Events'
			},
			sign: {
				headline: 'Sign up!',
				subheadline: 'Create an account to explore the best dog shows',
				button: 'Create an account'
			},
			contact: {
				headline: 'Contact',
				events: {
					headline: 'Discover Events',
					all: 'All Events'
				},
				socials: 'Follow us'
			},
			partners: 'Our Partners'
		},
		events: {
			rank: {
				international: 'international',
				national: 'national',
				club: 'club'
			},
			calendar: {
				from: 'From',
				to: 'To'
			},
			header: 'Events',
			myEvents: 'My Events',
			stripes: {
				judges: 'See all judges',
				all: 'See all'
			},
			buttons: {
				remind: 'Remind',
				unremind: 'Unremind',
				remindInfo: 'Remind me about each event’s application deadline 3 and 1 days beforehand, via e-mail.',
				sync: 'Synchronize',
				syncInfo: 'Synchronize events with my computer’s and/or phone’s calendar.'
			}
		},
		event: {
			rank: 'Rank',
			deadline: 'Application Deadline',
			fav: 'Add to My Events',
			remove: 'Remove from My Events',
			apply: 'Apply to show',
			hotel: 'Find your hotel with',
			location: 'Location',
			maps: 'See on',
			judges: 'Event Judges',
			breed: 'Breed',
			removeBreed: 'Remove breed',
			group: 'Group'
		},
		judges: {
			header: 'Judges',
			ratings: 'no ratings',
			reviews: 'Reviews',
			removeComment: 'Remove comment'
		},
		judge: {
			reviews: 'reviews',
			allComments: 'see all comments below',
			comment: 'Your Comment',
			name: 'Full Name',
			breed: 'Dog breed',
			remove: 'remove breed',
			anonymous: 'stay anonymous',
			opinion: 'Your opinion',
			rate: 'Rate the judge',
			button: 'Add Comment'
		},
		account: {
			header: 'Create Account',
			my: 'My Account',
			basics: {
				header: 'Name and Email',
				name: 'First Name',
				lastName: 'Last Name',
				email: 'Email'
			},
			adress: {
				header: 'Adress',
				street: 'Street',
				city: 'City',
				post: 'Post Code',
				country: 'Country',
				remove: 'Remove country',
				description: 'Please enter your address if you wish to search events also by distance from your place of residence.'
			},
			breeds: {
				header: 'My Breeds',
				breed: 'Breed',
				remove: 'Remove breed',
				description: 'Please enter your breeds if you wish to get more accurate search results of events suitable for you.',
				obligatory: 'Obligatory fields - at least one breed'
			},
			password: {
				header: 'Password',
				pass: 'Password',
				confirmPass: 'Password confirmation',
				newPass: 'New Password',
				newPassConfirmation: 'New Password Confirmation'
			},
			terms: {
				header: 'Terms and conditions apply:',
				agreements: {
					header: 'By clicking Create an Account you agree to our Terms and conditions and our Cookie policy.',
					first: 'First obligatory agreement',
					second: 'Second obligatory agreement',
					third: 'Third obligatory agreement'
				}
			},
			button: 'Create an Account',
			update: 'Update Account',
			obligatory: 'Obligatory fields'
		},
		noResults: 'No Results',
		pdf: 'Download as',
		back: 'Back',
		filters: {
			remove: 'Remove filter',
			narrow: 'Narrow By',
			search: 'Search By name',
			sort: 'Sort By',
			comments: 'Show comments narrow by',
			dog: 'Dog Breeds',
			group: 'Breed Group',
			rank: 'Event Rank',
			country: 'Country',
			distance: 'Distance',
			distanceFrom: 'from',
			date: 'Date',
			breeds: 'Breeds',
			judge: 'Judge name',
			all: 'All',
			future: 'Future',
			past: 'Past',
			letter: 'Alphabetic letter',
			name: 'Name',
			buttonResultsName: 'Filters',
			buttonNoResultsName: 'Nie wybrałeś żadnego filtra',
			stars: {
				name: 'Stars count',
				most: 'Most Stars',
				least: 'Least Stars'
			},
			reviews: {
				name: 'Reviews count',
				most: 'Most Reviews',
				least: 'Least Reviews'
			}
		},
		errors: {
			confirmedPassword: 'Password doesnt match',
			agreements: 'Check all obligatory agreements'
		}
	},
	hu: {
		nav: {
			events: 'Events',
			myEvents: 'My Events',
			createAccount: 'Create Account',
			judges: 'Judges',
			myAccount: 'My Account',
			logIn: 'Log In',
			logOut: 'Log Out',
			ranks: {
				all: 'All'
			}
		},
		logIn: {
			header: 'Log In',
			mail: 'E-mail',
			password: 'Password',
			signIn: 'Log in',
			or: 'or',
			create: 'Create an Account',
			forgotten: 'Forgotten your password?'
		},
		activation: {
			headline: 'Check your inbox!',
			subheadline: 'We send you activation link',
			confirmation: 'Your account is active now',
			sub: 'You can sign in!'
		},
		reset: {
			header: 'Reset password',
			button: 'Reset Password',
			cancel: 'Cancel',
			page: {
				headline: 'Check your inbox!',
				subheadline: 'We send you a password reset link',
				passwordChanged: 'Password has been changed',
				use: 'Use new Password to sign in!',
				set: 'Set new password!',
				newPass: 'New password',
				newPassConfirmation: 'New password confirmation',
				button: 'Set new Password'
			}
		},
		home: {
			header: {
				headline_discover: 'Discover',
				headline_rest: 'FCI dog shows across Europe',
				inputs: {
					breed: 'Breed',
					country: 'Country'
				},
				button: 'Discover Shows'
			},
			features: {
				user: {
					headline: 'User Friendly',
					description: 'Easily find all FCI dog shows across Europe in a simple and intuitive way'
				},
				plan: {
					headline: 'Plan & Sync',
					description: 'Plan your personal list of dog shows and synchronize it with your calendar'
				},
				opinions: {
					headline: 'Share Opinions',
					description: 'Check out and share your opinions about the dog show judges'
				}
			},
			slider: {
				headline: 'Events',
				subheadline: 'Most popular',
				button: 'See All Events'
			},
			sign: {
				headline: 'Sign up!',
				subheadline: 'Create an account to explore the best dog shows',
				button: 'Create an account'
			},
			contact: {
				headline: 'Contact',
				events: {
					headline: 'Discover Events',
					all: 'All Events'
				},
				socials: 'Follow us'
			},
			partners: 'Our Partners'
		},
		events: {
			rank: {
				international: 'international',
				national: 'national',
				club: 'club'
			},
			calendar: {
				from: 'From',
				to: 'To'
			},
			header: 'Events',
			myEvents: 'My Events',
			stripes: {
				judges: 'See all judges',
				all: 'See all'
			},
			buttons: {
				remind: 'Remind',
				unremind: 'Unremind',
				remindInfo: 'Remind me about each event’s application deadline 3 and 1 days beforehand, via e-mail.',
				sync: 'Synchronize',
				syncInfo: 'Synchronize events with my computer’s and/or phone’s calendar.'
			}
		},
		event: {
			rank: 'Rank',
			deadline: 'Application Deadline',
			fav: 'Add to My Events',
			remove: 'Remove from My Events',
			apply: 'Apply to show',
			hotel: 'Find your hotel with',
			location: 'Location',
			maps: 'See on',
			judges: 'Event Judges',
			breed: 'Breed',
			removeBreed: 'Remove breed',
			group: 'Group'
		},
		judges: {
			header: 'Judges',
			ratings: 'no ratings',
			reviews: 'Reviews',
			removeComment: 'Remove comment'
		},
		judge: {
			reviews: 'reviews',
			allComments: 'see all comments below',
			comment: 'Your Comment',
			name: 'Full Name',
			breed: 'Dog breed',
			remove: 'remove breed',
			anonymous: 'stay anonymous',
			opinion: 'Your opinion',
			rate: 'Rate the judge',
			button: 'Add Comment'
		},
		account: {
			header: 'Create Account',
			my: 'My Account',
			basics: {
				header: 'Name and Email',
				name: 'First Name',
				lastName: 'Last Name',
				email: 'Email'
			},
			adress: {
				header: 'Adress',
				street: 'Street',
				city: 'City',
				post: 'Post Code',
				country: 'Country',
				remove: 'Remove country',
				description: 'Please enter your address if you wish to search events also by distance from your place of residence.'
			},
			breeds: {
				header: 'My Breeds',
				breed: 'Breed',
				remove: 'Remove breed',
				description: 'Please enter your breeds if you wish to get more accurate search results of events suitable for you.',
				obligatory: 'Obligatory fields - at least one breed'
			},
			password: {
				header: 'Password',
				pass: 'Password',
				confirmPass: 'Password confirmation',
				newPass: 'New Password',
				newPassConfirmation: 'New Password Confirmation'
			},
			terms: {
				header: 'Terms and conditions apply:',
				agreements: {
					header: 'By clicking Create an Account you agree to our Terms and conditions and our Cookie policy.',
					first: 'First obligatory agreement',
					second: 'Second obligatory agreement',
					third: 'Third obligatory agreement'
				}
			},
			button: 'Create an Account',
			update: 'Update Account',
			obligatory: 'Obligatory fields'
		},
		noResults: 'No Results',
		pdf: 'Download as',
		back: 'Back',
		filters: {
			remove: 'Remove filter',
			narrow: 'Narrow By',
			search: 'Search By name',
			sort: 'Sort By',
			comments: 'Show comments narrow by',
			dog: 'Dog Breeds',
			group: 'Breed Group',
			rank: 'Event Rank',
			country: 'Country',
			distance: 'Distance',
			distanceFrom: 'from',
			date: 'Date',
			breeds: 'Breeds',
			judge: 'Judge name',
			all: 'All',
			future: 'Future',
			past: 'Past',
			letter: 'Alphabetic letter',
			name: 'Name',
			buttonResultsName: 'Filters',
			buttonNoResultsName: 'Nie wybrałeś żadnego filtra',
			stars: {
				name: 'Stars count',
				most: 'Most Stars',
				least: 'Least Stars'
			},
			reviews: {
				name: 'Reviews count',
				most: 'Most Reviews',
				least: 'Least Reviews'
			}
		},
		errors: {
			confirmedPassword: 'Password doesnt match',
			agreements: 'Check all obligatory agreements'
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/index.js